const axios = require('axios')

const postSurveyUrl = process.env.REACT_APP_HOST_API + '/post-survey'

export const checkPostSurvey = async (userId, sessionId) => {
  try {
    const res = await axios.get(`${postSurveyUrl}/check/${userId}/${sessionId}`)
    return res.data
  } catch (error) {
    console.error('Error checking post survey:', error)
    throw error
  }
}

export const submitPostSurvey = async (userId, sessionId, responses) => {
  try {
    const res = await axios.post(`${postSurveyUrl}/submit`, {
      userId,
      sessionId,
      ...responses
    })
    return res.data
  } catch (error) {
    console.error('Error submitting post survey:', error)
    throw error
  }
}

export const getPostSurveysBySession = async (sessionId) => {
  try {
    const res = await axios.get(`${postSurveyUrl}/session/${sessionId}`)
    return res.data
  } catch (error) {
    console.error('Error fetching post surveys:', error)
    throw error
  }
}

export const getInterestedParticipants = async (sessionId) => {
  try {
    const res = await axios.get(`${postSurveyUrl}/interested/${sessionId}`)
    return res.data
  } catch (error) {
    console.error('Error fetching interested participants:', error)
    throw error
  }
}